import React from 'react';
import { Link } from 'react-router-dom'
import Dropdown from 'react-bootstrap/Dropdown';
import WebAPI from '../api/WebAPI.js';
class MenuItem extends React.Component {

    constructor(props) {
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
    }
    handleOnClick(e) {
        if (this.props.menu.dynamic === 'Y') {
            //Now transform the URL and then simulate the click
            WebAPI.getData('/app/' + this.props.menu.id + '/url', {}).then(response => {
                if (this.props.menu.newwindow === 'Y') {
                    window.open(response.data.url, response.data.id);
                } else {
					if(window.hasToken(response.data.url) && window.isSameDomain(response.data.url)){
						window.openApp(response.data.url);
					} else {
						window.open(response.data.url, '_self');
					}
                }
            }).catch(err => {});
            e.preventDefault();
        }

    }
    render(props) {
        const menu = this.props.menu;
        if (menu.dynamic === "Y") {
            return (
                <Dropdown.Item
                /* className='btn-account' */
                key={menu.id} href={menu.url} target={menu.newwindow === 'Y' ? menu.id : ''} onClick={(e) => { this.handleOnClick(e) }}>
                    {menu.name}
                </Dropdown.Item>
            );
        }

        if (menu.url.startsWith("https://") || menu.url.startsWith("http://")) {
            return (
                <Dropdown.Item
                /*  className='btn-account' */
                 key={menu.id} href={menu.url} target={this.props.menu.newwindow === 'Y' ? menu.id : ''}>
                    {menu.name}
                </Dropdown.Item>
            );
        }

        return (
            <Dropdown.Item key={menu.id} as={Link} to={menu.url}>
                {menu.name}
            </Dropdown.Item>
        );
    }
}

export default MenuItem;